import React from 'react';
import { connect } from 'react-redux';

import { Form } from 'components/common';
import MainFieldSet from './MainFieldSet';


const SeoTemplatePageForm = (props) => {
  const { showEditForm } = props.seoTemplatePage;

  const onClose = () => {
    props.actions.seoTemplatePage.showEditForm({ show: false });
  };

  const onSubmit = (data) => {
    const newData = Object.assign(data, {
      site: props.site.activeId,
    });
    console.log(newData);
    props.actions.seoTemplatePage.update(newData);
  };

  const initialValues = {
    page_type: 'product_detail',
    tpl_path: '[name]',
    tpl_title: '[name]',
    tpl_h1: '[name]',
  };

  return (
    <Form
      width={800}
      title="Редактирование шаблона страницы"
      model={props.seoTemplatePage}
      visible={showEditForm}
      onClose={onClose}
      onSubmit={onSubmit}
      initialValues={initialValues}
      convertEditObject={(editObject) => ({
        ...editObject,
      })}
    >
      <MainFieldSet {...props} initialValues={initialValues} />
    </Form>
  );
};

const mapState = (state) => ({
  site: state.site,
  auth_token: state.auth.token,
  seoTemplatePage: state.seoTemplatePage,
});

const mapDispatch = (dispatch) => ({
  actions: {
    seoTemplatePage: dispatch.seoTemplatePage,
  },
});

export default connect(mapState, mapDispatch)(SeoTemplatePageForm);
